export const GETGRADE_SUCCESS = "GETGRADE_SUCCESS";
export const GETGRADE_ERROR = "GETGRADE_ERROR";

export const ADDGRADE_SUCCESS = "ADDGRADE_SUCCESS";
export const ADDGRADE_ERROR = "ADDGRADE_ERROR";

export const UPDATEGRADE_SUCCESS = "UPDATEGRADE_SUCCESS";
export const UPDATEGRADE_ERROR = "UPDATEGRADE_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";


